import { useContext } from "react";
import { Input } from "antd";

import { SpecSettingContext } from "../../../pages/SpecSetting";

const { TextArea } = Input;

const MemoStep = ({ approval }) => {
  const { blueprint, updateSettingBlueprint } = useContext(SpecSettingContext);

  return (
    <TextArea
      disabled={approval}
      rows={5}
      placeholder="請輸入筆記"
      value={
        blueprint["blueprintMemo"]?.startsWith("\n")
          ? blueprint["blueprintMemo"].slice(1)
          : blueprint["blueprintMemo"]
      }
      onChange={(e) => updateSettingBlueprint("blueprintMemo", e.target.value)}
    />
  );
};

export default MemoStep;
